import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { FilterConfig } from '../../../../../../../packages/filter/src/public-api';
import { FilterService } from '../../../shared/services/filter/filter.service';
import { testStore } from '../test.store';

@Injectable()
export class TestResolver {
  readonly store = inject(testStore);

  private filterService = inject(FilterService);

  constructor() {}
  resolve: ResolveFn<void> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void => {
    const filterConfig: FilterConfig.FullFilterItemConfig[] = [
      {
        label: "Type d'intêret",
        cat: 'interest_type',
        type: 'list',
        values: [],
      },
      {
        label: 'Statut',
        cat: 'status',
        type: 'list',
        valueFormatter: (value: string) => {
          return value[0].toLocaleUpperCase() + value.slice(1).toLocaleLowerCase();
        },
        invertedValueFormatter: (value: string) => {
          return value.toLocaleLowerCase();
        },
        values: [],
      },
      {
        label: 'Affaire',
        cat: 'affaire.name',
        type: 'list',
        values: [],
      },
      {
        label: 'Agences / MRA',
        cat: 'business_introducer.name',
        type: 'list',
        values: [],
      },
      {
        label: 'Vendeur',
        cat: "(INITCAP(user_account.firstname) || ' ' || UPPER(user_account.lastname))",
        type: 'list',
        values: [],
      },
      {
        label: 'Date de création',
        cat: 'indic.creation_date',
        type: 'date',
        values: [],
      },
      {
        label: 'Marque',
        cat: 'brand.name',
        type: 'list',
        values: [],
      },
      {
        label: 'Plus de 6 mois',
        cat: `CASE WHEN ((indic.status = 'nouveau' OR indic.status = 'en cours' OR indic.status = 'en retard') AND (indic.creation_date < NOW() - INTERVAL '6 months')) THEN true ELSE false END`,
        type: 'check',
        values: [],
      },
    ];

    let currentFilterList: FilterConfig.FullFilterItemConfig[] = this.filterService.getCurrentFilterList(route, filterConfig);

    currentFilterList.length > 0
      ? sessionStorage.setItem('cdl_list_indics_filter', JSON.stringify(currentFilterList))
      : sessionStorage.removeItem('cdl_list_indics_filter');

    this.store.setCurrentFilterList(currentFilterList);
    this.store.setFilterConfig(filterConfig);
  };
}
